import { Center, Loader } from '@mantine/core';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks';

interface ProtectedRouteProps {
  children: ReactNode;
}

/** Redirects to `/login` if the user isn't signed in. */
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { firebaseUser, appUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }

  if (!firebaseUser) {
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  }

  // Force a password change before anything else if it's outstanding (first
  // login after admin-creation, or after an admin password reset).
  if (appUser?.mustChangePassword && location.pathname !== '/account/change-password') {
    return <Navigate replace to="/account/change-password" />;
  }

  return <>{children}</>;
};
